<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"background: #FEF8F4;\nbackground: linear-gradient(0deg, rgba(254, 248, 244, 1) 0%, rgba(249, 250, 249, 1) 100%);\npadding: 32px 0px;"' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"padding-top:64px;"' class="container-custom mx-auto" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center mx-auto align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 order-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="section-right-wrapper" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"font-size: 3rem;\n"' class="title-h2-hero" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="text-primary" >
                <template #default>درباره   </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>امید نورانی   </template>
                </m-span></template>
                </m-h1><m-h2 v-bind='{...{},...{}}' :style='"font-size: 1.2rem;"' class="my-5 text-caption" >
                <template #default>برای موفقیت در کنکور، هم امتحانات نهایی و هم آزمون سراسری رو باید بترکونی! همه‌ی این مسیر هم با درس ریاضی درگیر هستی! هدف ما کسب نمرات خوب و درصد عالی هست و این جز با یادگیری مفهومی، آموزش تستی و تشریحی، بررسی نمونه سوالات و روش تدریس مناسب قابل حل نیست.
اینجا همون جایی هست که کاملا همراه شماست تا موفقیت!   </template>
                </m-h2><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-start" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='"font-size:13px;"' class=" mx-2 text-primary border-primary col-lg-4 col-md-5 mb-2" >
                <template #default>بازگشت به صفحه اصلی   <m-icon v-bind='{...{"icon":""},...{}}' :style='""' class="bi bi-arrow-left-circle-fill mx-1" ></m-icon></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6  order-1 order-lg-2 text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"position: relative;\ndisplay: inline-block;"' class="mt-4" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.omidnoorani.ir\/storage\/icons\/tig6QWBiYyuJJ12N6UKioXqP1MjqHQnNB5JaFwWL-1782124161.png","alt":"omidnoorani"},...{}}' :style='"height: 300px;\nwidth:auto;"' class="hero-img-1" ></m-img></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='"padding: 64px 0px;"' class="container-fluid bg-white text-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container-custom" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-center align-items-center mx-auto " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="custom-card-about-us p-2 rounded m-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center  d-flex justify-content-center align-items-center" >
                <template #default>   <m-icon v-bind='{...{"icon":"award"},...{}}' :style='"font-size: 35px;\nborder-radius: 8px;\n"' class="  bg-secondary  d-flex p-3 rounded-circle text-primary my-4" ></m-icon></template>
                </m-div><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ضمانت کیفیت
   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='"font-size: 14px;"' class="py-2" >
                <template #default>بهترین کیفیت محصولات 
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="custom-card-about-us" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center  d-flex justify-content-center align-items-center" >
                <template #default>   <m-icon v-bind='{...{"icon":"alarm"},...{}}' :style='"font-size: 35px;\nborder-radius: 8px;\n"' class="  bg-secondary  d-flex p-3 rounded-circle text-primary my-4" ></m-icon></template>
                </m-div><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>قیمت مناسب   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='"font-size: 14px;"' class="py-2" >
                <template #default>ارائه با کیفیت ترین محصولات با مناسب ترین قیمت
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="custom-card-about-us" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center  d-flex justify-content-center align-items-center" >
                <template #default>   <m-icon v-bind='{...{"icon":"patch-check"},...{}}' :style='"font-size: 35px;\nborder-radius: 8px;\n"' class="  bg-secondary  d-flex p-3 rounded-circle text-primary my-4" ></m-icon></template>
                </m-div><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برنامه تخصصی   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='"font-size: 14px;"' class="py-2" >
                <template #default>برنامه تخصصی مخصوص پرنده شما    </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="custom-card-about-us" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center  d-flex justify-content-center align-items-center" >
                <template #default>   <m-icon v-bind='{...{"icon":"file-earmark-person"},...{}}' :style='"font-size: 35px;\nborder-radius: 8px;\n"' class="  bg-secondary  d-flex p-3 rounded-circle text-primary my-4" ></m-icon></template>
                </m-div><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تیم متخصص   </template>
                </m-h5><m-p v-bind='{...{},...{}}' :style='"font-size: 14px;"' class="py-2" >
                <template #default>تیم ما از متخصصین مجرب و با تجربه تشکیل شده است   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mSpan,mH2,mA,mIcon,mImg,mH5,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
